import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

interface RelatedPagesProps {
  currentPage: 'privacy' | 'terms' | 'documentation' | 'support';
}

const RelatedPages: React.FC<RelatedPagesProps> = ({ currentPage }) => {
  const { darkMode } = useTheme();
  const pages = [
    {
      id: 'privacy',
      title: 'Privacy Policy',
      description: 'Kebijakan privasi dan perlindungan data pribadi',
      icon: 'fa-shield-halved',
      path: '/privacy-policy',
      color: 'violet'
    },
    {
      id: 'terms',
      title: 'Terms of Service',
      description: 'Syarat dan ketentuan penggunaan layanan',
      icon: 'fa-file-contract',
      path: '/terms-of-service',
      color: 'violet'
    },
    {
      id: 'documentation',
      title: 'Documentation',
      description: 'Panduan lengkap penggunaan aplikasi',
      icon: 'fa-book',
      path: '/documentation',
      color: 'violet'
    },
    {
      id: 'support',
      title: 'Support',
      description: 'Bantuan dan kontak tim support',
      icon: 'fa-life-ring',
      path: '/support',
      color: 'violet'
    }
  ].filter(page => page.id !== currentPage);

  return (
    <div className={`mt-12 pt-8 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'} transition-colors duration-300`}>
      <h3 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'} transition-colors duration-300`}>Konten Lainnya</h3>
      <div className="grid md:grid-cols-3 gap-4">
        {pages.map((page) => (
          <Link
            key={page.id}
            to={page.path}
            className={`p-6 border rounded-lg hover:border-violet-300 hover:shadow-md transition-all group ${
              darkMode 
                ? 'bg-gray-800 border-gray-700 hover:border-violet-500' 
                : 'bg-white border-gray-200'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${
                darkMode 
                  ? 'bg-violet-900/30 group-hover:bg-violet-800/50' 
                  : 'bg-violet-100 group-hover:bg-violet-200'
              }`}>
                <i className={`fa-solid ${page.icon} text-violet-600 text-xl`}></i>
              </div>
              <div className="flex-1">
                <h4 className={`text-lg font-semibold mb-1 group-hover:text-violet-600 transition-colors ${
                  darkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  {page.title}
                </h4>
                <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  {page.description}
                </p>
                <div className="mt-3 text-sm text-violet-600 font-medium flex items-center">
                  Baca selengkapnya
                  <i className="fa-solid fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPages;

